import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import PitchMode from "./PitchMode";
import PitchAirlineRoute from "./components/pitch/routes/PitchAirlineRoute";
import PitchAccessRoute from "./components/pitch/routes/PitchAccessRoute";

// Public generic pitch (mounts with the default/generic airline config).
const PublicPitch = () => <PitchMode airline={null} />;

function AppWithRouter() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<PublicPitch />} />
        <Route path="/pitch" element={<PitchAccessRoute />} />
        <Route path="/pitch/:code" element={<PitchAirlineRoute />} />
        {/* Legacy /landing → redirect permanently to public pitch */}
        <Route path="/landing" element={<Navigate to="/" replace />} />
        {/* Catch-all → public pitch */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default AppWithRouter;
